"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchService = void 0;
const tslib_1 = require("tslib");
class FetchService {
  constructor() {
    this.maxDuration = 30000;
    this.useTimeout = false;
    if (FetchService.instance) {
      return FetchService.instance;
    }
    FetchService.instance = this;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  http(url, options) {
    if (this.useTimeout) {
      return this.fetchWithTimeout(url, options);
    } else {
      return this.fetchHttp(url, options);
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchHttp(url, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      let response;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let result;
      try {
        response = yield fetch(url, options);
        result = yield this.parseResponseResult(response);
        if (!response.ok) {
          throw response;
        }
        if (typeof this.handleResponse === 'function') {
          this.handleResponse(response);
        }
        return result;
      } catch (_a) {
        if (typeof this.handleError === 'function') {
          this.handleError({
            response,
            result
          });
        }
        return Promise.reject({
          response,
          result
        });
      } finally {
        if (this.logger != null) {
          this.logger.debug(`${(response === null || response === void 0 ? void 0 : response.ok) ? 'http-call' : 'http-call-error'} ${response === null || response === void 0 ? void 0 : response.status} ${options.method} ${url.split('?')[0]}`, null, {
            request: Object.assign({
              url
            }, options),
            response
          });
        }
      }
    });
  }
  parseResponseResult(response) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const result = yield response.text();
      if (result) {
        try {
          return JSON.parse(result);
        } catch (_a) {
          return result;
        }
      }
      return result;
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchWithTimeout(url, options) {
    return Promise.race([this.fetchHttp(url, options), new Promise((resolve, reject) => {
      setTimeout(() => reject(new Error(`https request timeout after ${this.maxDuration}ms`)), this.maxDuration);
    })]);
  }
}
exports.FetchService = FetchService;
FetchService.instance = null;
